import React from 'react';
import { Spin } from 'antd';
import styles from './FullScreenSpinner.module.scss';

interface FullScreenSpinnerProps {
  message?: string;
  size?: 'small' | 'default' | 'large';
}

export const FullScreenSpinner: React.FC<FullScreenSpinnerProps> = ({
  message,
  size = 'large',
}) => {
  return (
    <div className={styles.container}>
      <Spin size={size} />
      {message && <p className={styles.message}>{message}</p>}
    </div>
  );
};

export default FullScreenSpinner;
